import { Button } from "@powerdiary/components-library/lib";
import { ButtonHTMLAttributes, FunctionComponent } from "react";

interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
    isBusy: boolean;
    text: string;
    loadingText: string;
}

export const SpinnerButton: FunctionComponent<IProps> = (props: IProps) => {
    const { isBusy, text, loadingText, onClick, type } = props;

    return (
        <Button variant="contained" size="medium" disabled={isBusy} onClick={onClick} type={type}>
            {isBusy && <span className="spinner-border spinner-border-sm"></span>}
            {isBusy ? ` ${loadingText}` : text}
        </Button>
    );
};
